import { createContext, useContext, useState } from "react";
import { INITIAL_CHECKOUT_CONTEXT_STATE } from "./utils/constants";
import { useCheckoutData } from "./utils/useCheckoutData";
import { useDeviceData } from "./utils/useDeviceData";
import { useCheckoutPayment } from "./utils/useCheckoutPayment";

const CheckoutContext = createContext(INITIAL_CHECKOUT_CONTEXT_STATE);

const CheckoutProvider = ({ children }) => {
  const { device } = useDeviceData();
  const [couponApplied, setCouponApplied] = useState("");
  const {
    isLoading: isCheckoutLoading,
    setDisableSubmitPayment,
    setPayment,
    ...checkoutData
  } = useCheckoutData({ device });
  const { isLoading: isPaymentLoading, ...paymentData } = useCheckoutPayment({
    setDisableSubmitPayment,
    setPayment
  });

  const isLoading = isCheckoutLoading || isPaymentLoading;

  return (
    <CheckoutContext.Provider
      value={{
        ...checkoutData,
        ...paymentData,
        isLoading,
        device,
        setPayment,
        setDisableSubmitPayment,
        couponApplied,
        setCouponApplied,
        getCheckoutData: checkoutData.getCheckoutData
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

const useCheckoutContext = () => useContext(CheckoutContext);

export { CheckoutProvider, useCheckoutContext };
